<template>
  <section class="policy-added">
    <h2>Policy Added</h2>
    <div class="box">
      <p>The policy has been added to the customer’s account.</p>
      <v-button
        type="success"
        @click="returnTicket">Return to Ticket</v-button>
    </div>
    <div class="box">
      <h3>View Policy</h3>
      <v-button @click="routerPolicy">View Policy</v-button>
    </div>
    <div class="document-box">
      <h3>Upload Documents</h3>
      <div
        v-for="(item, index) in invoiceList"
        :key="index"
        class="card">
        <div class="header flex-sb">
          <div>
            <span class="title">{{ item.type_language }}</span>
            <!-- <span class="date">{{ item.period_start }}</span> -->
          </div>
          <div>
            <v-button
              type="primary"
              @click="handlerManualEdit(index)">Edit</v-button>
          </div>
        </div>
        <el-table
          :data="item.record"
          stripe
          style="width: 100%">
          <el-table-column
            prop="document"
            label="Document"></el-table-column>
          <el-table-column
            prop="from"
            label="From"></el-table-column>
          <el-table-column
            prop="uploaded_by"
            label="Uploaded By"></el-table-column>
          <el-table-column label="File">
            <template slot-scope="scope">
              <section>
                <span
                  v-if="scope.row.file && scope.row.file.url"
                  class="blue pointer"
                  @click="openFile(scope.row.file.url)"
                >{{ scope.row.file.client_name }}</span>
                <span
                  v-else
                  class="missing">Missing</span>
              </section>
            </template>
          </el-table-column>
        </el-table>
      </div>
    </div>

    <v-dialog
      v-model="dialog"
      width="700px">
      <div class="dialog-container">

        <h3>Edit Policy & Invoice</h3>
        <!-- <div class="form-item form-half">
          <span>{{action_type_lang}}</span>
          <v-date-picker v-model="formData.pcy_cmnt_dt" />
        </div> -->
        <el-table
          :data="recordData.data"
          stripe
          style="width: 100%">
          <el-table-column
            prop="document"
            label="Document"></el-table-column>
          <el-table-column
            prop="from"
            label="From"></el-table-column>
          <el-table-column
            prop="uploaded_by"
            label="Uploaded By"></el-table-column>
          <el-table-column label="File">
            <template slot-scope="scope">
              <section>
                <span
                  v-if="scope.row.file && scope.row.file.url"
                  class="blue pointer"
                  @click="openFile(scope.row.file.url)"
                >{{ scope.row.file.client_name }}</span>
                <span
                  v-else
                  class="missing">Missing</span>
              </section>
            </template>
          </el-table-column>
          <el-table-column label="Action">
            <template slot-scope="scope">
              <v-upload
                btnType="text"
                :uploadData="{
                  order_id: recordData.id,
                  type: scope.row.type
                }"
                :otherData="{
                  index: scope.$index
                }"
                :direct="0"
                :label="(scope.row.file && scope.row.file.url)? 'Replace': 'Upload'"
                @uploadSuccess="handlerUploadSuccess"
              />
            </template>
          </el-table-column>
          <el-table-column>
            <template slot-scope="scope">
              <span
                v-if="scope.row.file && scope.row.file.url"
                class="danger pointer"
                @click="handlerDelete(scope.$index, scope.row.type)"
              >Delete</span>
            </template>
          </el-table-column>
        </el-table>
        <div class="dialog-footer flex-sb">
          <div>
            <v-button @click="dialog = false">Close</v-button>
          </div>
          <div>
            <!-- <v-button
              type="primary"
              @click="onConfirm">Confirm</v-button> -->
          </div>
        </div>
      </div>
    </v-dialog>
  </section>
</template>
<script>
import { deleteOrderFile } from '@/api/order'
import { getManualPolicyDetail, addManualPolicyInvoice, editManualPolicyInvoice } from '@/api/policy'
export default {
  name: 'PolicyAdded',
  props: {
    detail: {
      type: Object,
      default: () => ({})
    }
  },
  data() {
    return {
      detailData: {},
      invoiceList: [],
      recordData: {},
      action_type_lang: '',
      dialog: false ,
      formData: {
        pcy_cmnt_dt: ''
      }  
    }
  },
  computed: {
    orderId() {
      const { id = '' } = this.policyData || {}
      return id
    },
    policyData() {
      const { business_policy = [] } = this.detail
      if(!business_policy || business_policy.length == 0) {
        return {}
      }
      return business_policy[business_policy.length - 1]
    },
    policyInvoice() {
      const { policy_invoice } = this.detailData
      return policy_invoice
    }
  },
  watch: {
    orderId: {
      immediate: true,
      handler(val) {
        if(val) {
          this.network().getManualPolicyDetail()
        }
      }
    },
    policyInvoice: {
      immediate: true,
      deep: true,
      handler(val) {
        if(val) {
          const value = JSON.parse(JSON.stringify(val))
          this.handler().handlerInvoiceList(value)
        }
      }
    }
  },
  methods: {
    returnTicket() {
      this.$emit('cancel')
    },
    routerPolicy() {
      const { pcy_id, id, product_id } = this.policyData
      this.$router.push({
        path: product_id > 50? '/records/policy/manual/detail': '/records/policy/detail',
        query: {
          id,
          product_id,
          pcy_id
        }
      })
    },
    openFile(url) {
      if (url) {
        window.open(url, '_blank')
      }
    },
    handlerManualEdit(index) {
      // this.recordData = this.invoiceList[index]
      this.recordData = {
        id: this.invoiceList[index].id,
        data: this.invoiceList[index].record
      }
      this.action_type_lang = this.invoiceList[index].type_language
      
      this.dialog = true
    },
    handlerUploadSuccess({ data, result, otherData }) {
      const { index } = otherData

      const { type } = this.recordData.data[index]

      let resultData = {
        ...this.recordData.data[index],
        file: data,
        from: 'HoldCover',
        uploaded_by: 'HoldCover'
      }
      this.$set(this.recordData.data, index, resultData)
    },
    handlerDelete(index, type) {
      this.network().deleteOrderFile(index, type)
    },
    onConfirm() {
      this.network().editManualPolicyInvoice()
    },
    handler() {
      return {
        getHandlerData: (data = []) => {
          return data.reduce((result, item) => {
            if (item.type === 'other') {
              const { file } = item
              if (file) {
                for (let i = 0; i < file.length; i++) {
                  result.push({
                    ...item,
                    index: i,
                    file: file[i],
                  })
                }
              } else {
                result.push({
                  ...item,
                  index: 0,
                  file: null,
                })
              }
            } else if (item.document == 'Brochure') {
              result.push({
                ...item,
                isBrochure: true,
              })
            } else {
              result.push(item)
            }
            return result
          }, [])
        },
        handlerInvoiceList: (invoiceData) => {
          let result = []
          let temp
          temp = JSON.parse(JSON.stringify(invoiceData))
          temp.map((item) => {
            item.record = this.handler().getHandlerData(item.record)
            return item
          })
          result = temp

          this.invoiceList = result
        },
      }
    },
    network() {
      return {
        getManualPolicyDetail: async () => {
          const { data } = await getManualPolicyDetail({
            order_id: this.orderId,
          })
          this.detailData = data
        },
        editManualPolicyInvoice: async () => {
          const { data } = await editManualPolicyInvoice({
            order_id: this.orderId,
            pcy_cmnt_dt: this.formData.pcy_cmnt_dt,
            file_data: this.recordData.data
          })
          this.dialog = false
        },
        deleteOrderFile: async (index, type) => {
          const { data } = await deleteOrderFile({
            order_id: this.recordData.id,
            type,
          })
          this.$message({
            type: 'success',
            message: data.message_language,
          })

          let localData = this.recordData.data[index]
          const params = {
            ...localData,
            file: null,
            from: '',
            uploaded_by: '',
          }

          this.$set(this.recordData.data, index, params)


          // 更新表格数据

          //   this.$set(this.invoiceList[invoiceIndex].record, index, params)

        },
      }
    }
  }
}
</script>
<style lang="scss" scoped>
.policy-added {
    padding: 20px;
    .box {
        padding: 20px 0;
        p {
            padding-bottom: 20px;
            font-size: 14px;
            color: #24292E;
        }
        border-bottom: 1px solid #E1E4E8;
    }
    .document-box {
        padding: 20px 0;
        width: 690px;
        .missing {
            color: #91939a;
            font-size: 12px;
            font-style: italic;
        }
        .header {
            align-items: center;
            padding-top: 0;
            padding-bottom: 10px;
            font-size: 16px;
            .title {
            color: #616266;
            font-weight: 500;
            font-size: 16px;
            }
            .date {
            padding-left: 10px;
            color: #91939a;
            }
        }
    }
    .dialog-container {
    padding: 15px;
    .missing {
      color: #91939a;
      font-size: 12px;
      font-style: italic;
    }
    .danger {
      color: #f56c6d;
    }
    .dialog-header {
      color: #616266;
      h3 {
        display: inline-block;
        padding-right: 15px;
      }
      .date {
        font-size: 16px;
      }
    }
    .btn-list {
      display: flex;
      flex-direction: column;
      align-items: center;
      .el-button {
        display: block;
        margin: 0 auto 10px auto!important;
      }
    }
    .dialog-footer {
      padding-top: 15px;
    }
  }
}
</style>